<script setup>
import axios  from "axios";
import Chart from 'chart.js/auto';
import { Colors } from 'chart.js';
Chart.register(Colors);
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-dialog
        v-model="media_dsp_flg"
        width="600px"
    >
        <v-card
            flat
            tile
        >
        <v-toolbar
            flat
            tile
            dense
            color="#E13533"
            dark
        >
            <v-toolbar-title
            >
                {{ media_detail.title }}
            </v-toolbar-title>
            <v-spacer>
            </v-spacer>
            <v-btn
                icon
                @click="media_dsp_flg=false"
            >
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-toolbar>

            <v-card-text class="mt-5 pb-2">
                <v-row>
                    <v-col cols="3" v-if="media_detail.ogp_discription!='' && media_detail.ogp_discription!=null">
                        <v-img
                            :src=media_detail.ogp_image
                            max-height="80px"
                            max-width="150px"
                            contain
                            style="margin : 0 auto"
                        ></v-img>
                    </v-col>
                    <v-col class="pt-3">
                        {{ media_detail.ogp_discription }}
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text class="py-2 px-2">
                <v-list
                    class="py-0"
                >
                    <v-list-item
                        v-for="corps in disp_op_corp(media_detail.op_ids,media_detail.op_corp_names)"
						:key="corps.id"
                        style="min-height:30px!important"
                    >
                        <span class="corp_name">{{ corps.name }}</span>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-text class="pl-10">
                <v-row>
                    <v-col>
                        <span class="account_num">{{  Number(media_detail.doc_pfm).toLocaleString()  }}</span>記事
                    </v-col>
                    <v-col>
                        自社モニタリング：<span class="account_num">{{ Number(media_detail.cdn_num).toLocaleString() }}</span>記事
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pl-10">
                SNS等アカウント:
                <span v-for="data,index in disp_account_data(media_detail.account)" :key="index">
                    <span v-if="index == 0" >公式アカウント</span>
                    <span v-else-if="index == 1">代表（編集長）</span>
                    <span v-else>編集者・ライター</span>
                    <span class="account_num">{{ data }}</span>
                </span>
            </v-card-text>
            <v-card-text>
                <div  v-if="media_detail.doc_pfm != '-'">
                    <canvas id="MEDIA_CHART" width="500px"></canvas>
                </div>
            </v-card-text>
            <v-card-title>
                サイトステータス
            </v-card-title>
            <v-card-text class="pl-8 mt-2 status_list">
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">分類</span>
                    </v-col>
                    <v-col>
                        {{ media_detail.label }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">サイト規模</span>
                    </v-col>
                    <v-col>
                        {{ media_detail.scl }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">閲覧者</span>
                    </v-col>
                    <v-col>
                        {{ media_detail.pv }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">ツイート</span>
                    </v-col>
                    <v-col>
                        {{ media_detail.tweet }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">月間総ページビュー</span>
                    </v-col>
                    <v-col>
                        {{ Number(media_detail.page_view).toLocaleString() }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-text>
            <v-card-title>
                サイト状態
            </v-card-title>
            <v-card-text class="pl-8 mt-2 status_list">
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">週間記事数</span>
                    </v-col>
                    <v-col>
                        {{ Number(media_detail.doc_num).toLocaleString() }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5">
                        <span class="detail_label">週間ツイート引用数</span>
                    </v-col>
                    <v-col>
                        {{ media_detail.tweet_num }}
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default{
    data () {
      return {
            media_dsp_flg : false,
            media_detail : [],
            ChartData    : null,
            chart        : null,
        }
    },
    methods : {
        open : async function(site_id){
            var params = new URLSearchParams();
            params.append('site_id',site_id);
            await axios.post("/api/media/get_media",params)
            .then(response => {
                this.media_detail = response.data;
                this.media_dsp_flg = true;
                this.$nextTick(function(){
                    // レンダリング後の処理
                    this.view_chart(site_id);
                 });
            });
        },
        disp_op_corp : function (op_ids,op_names) {
            if (op_ids === '')
            {
                return "";
            }
            let data = Array();
            let ids = Array();
            let names = Array();
            if(op_ids != null)
                ids = op_ids.toString().split(',');
            if(op_names != null)
                 names = op_names.split(',');
            for(let i = 0 ; i < ids.length ; i++)
            {
                data.push({id:ids[i],name:names[i]});
            }
            return data;
        },
        disp_account_data : function (account_string){
            if (account_string === '' || account_string === undefined)
            {
                return "";
            }
            let data = Array();
            data = account_string.toString().split(',');

            return data;
        },
        view_chart : async function(site_id) {
            var params = new URLSearchParams();
            params.append('site_id', site_id);
            await axios.post("/api/chart/get_media_doughnut",params)
            .then(response => {
                //this.ChartData = response.data;
				let aspect = 500 / 300;
				this.ChartData = {
					type : response.data.type,
					data : response.data.data,
					responsive :false,
					maintainAspectRatio : false,
					aspectRatio : aspect,
					options : {
						plugins : {
							legend : response.data.options.legend,
							title  : response.data.options.title,
						},
					}
				};
				/*
                const projectResult = document.querySelectorAll('#MEDIA_CHART');
                var ctx = projectResult[0].getContext('2d')
				*/
				let ctx = document.getElementById('MEDIA_CHART');
                if(this.chart != null)
                {
                    this.chart.destroy();
                }
                this.chart = new Chart(ctx, this.ChartData);
				//this.chart.canvas.parentNode.style.height = '300px';
				//this.chart.canvas.parentNode.style.width = '550px';
            });
        },
    },
}
</script>
<style>
<style>
.detail_label{
    font-weight:600;
}
.corp_name{
    font-size:1.5rem;
    font-weight:500;
}
.status_list .col{
    margin:5px auto;
}
</style>
